import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import { Wrapper } from './EducationalCodeEthics.elements';

export const EDUCATIONALCODEETHICS_ID = 'EducationalCodeEthics';

export interface EducationalCodeEthicsProps { }

const EducationalCodeEthicsTemplate: FC<EducationalCodeEthicsProps> = () => {
    return (
        <Wrapper>


            <div className="title" id={`${EDUCATIONALCODEETHICS_ID}-sekcia`}>
                Etický kódex pre oblasť personálneho zabezpečenia vzdelávacej činnosti
            </div>
            <div className="subTitle">
                Poradca podnikateľa, s. r. o. – úsek Vzdelávanie, platforma Profivzdelávanie.sk
            </div>




            <h1 className="sectionTitle">Úvod</h1>
            <p >Tento etický kódex stanovuje záväzné pravidlá a etické princípy pre všetky osoby zapojené do personálneho zabezpečenia vzdelávacej činnosti v rámci platformy Profivzdelávanie spoločnosti Poradca podnikateľa. Dokument vytvára jednotný štandard pre výber, koordináciu, odborné vedenie, kontrolu a hodnotenie lektorov, garantov, interných metodikov a administratívnych pracovníkov.</p>


            <h1 className="sectionTitle">1. Poslanie a účel kódexu</h1>
            <p >Cieľom kódexu je:</p>
            <ul >
                <li  >zaistiť dôveryhodnosť, transparentnosť a profesionalitu vzdelávacích služieb,</li>
                <li  >chrániť účastníkov vzdelávania a podporovať férový prístup,</li>
                <li  >stanoviť etické štandardy pre všetky pracovné role vo vzdelávacom procese,</li>
                <li  >predchádzať konfliktom záujmov a neetickému správaniu.</li>
            </ul>
            <h1 className="sectionTitle">2. Základné hodnoty</h1>
            <ul >
                <li  ><strong>Profesionalita</strong> – kvalifikovaný, odborný a zodpovedný výkon.</li>
                <li  ><strong>Nestrannosť</strong> – rovnaké podmienky pre všetkých účastníkov.</li>
                <li  ><strong>Integrita</strong> – čestnosť, transparentnosť, spoľahlivosť.</li>
                <li  ><strong>Rešpekt</strong> – úcta k účastníkom, kolegom, rozmanitosti a ľudskej dôstojnosti.</li>
                <li  ><strong>Odborný rast</strong> – priebežné vzdelávanie a zlepšovanie vlastných kompetencií.</li>
            </ul>
            <h1 className="sectionTitle">3. Etické zásady pre lektorov</h1>
            <ul >
                <li  >konať odborne, zodpovedne a v súlade s aktuálnymi poznatkami v odbore,</li>
                <li  >rešpektovať individuálne potreby účastníkov a podporovať inkluzívne prostredie,</li>
                <li  >zaručiť pravdivosť a odbornosť informácií,</li>
                <li  >dodržiavať mlčanlivosť o osobných údajoch účastníkov,</li>
                <li  >správať sa kultúrne, profesionálne a férovo,</li>
                <li  >neprijímať dary alebo protislužby za individuálne zvýhodnenie účastníka.</li>
            </ul>
            <h1 className="sectionTitle">4. Etické zásady pre garanta vzdelávania</h1>
            <ul >
                <li  >zabezpečovať odbornú úroveň obsahu a metodickú správnosť,</li>
                <li  >dohliadať na aktualizáciu vzdelávacích materiálov a súlad s legislatívou,</li>
                <li  >kontrolovať prácu lektorov a poskytovať im spätnú väzbu,</li>
                <li  >vykonávať svoju úlohu nestranne a bez konfliktu záujmov.</li>
            </ul>
            <h1 className="sectionTitle">5. Etické zásady pre administratívnu a organizačnú podporu</h1>
            <ul >
                <li  >poskytovať účastníkom presné a pravdivé informácie,</li>
                <li  >zabezpečiť dostupnosť a komfort účastníkov počas celého vzdelávacieho procesu,</li>
                <li  >zodpovedne chrániť osobné údaje a dokumentáciu,</li>
                <li  >komunikovať trpezlivo, otvorene a profesionálne.</li>
            </ul>
            <h1 className="sectionTitle">6. Konflikt záujmov</h1>
            <p >Osoby zapojené do vzdelávacej činnosti sú povinné:</p>
            <ul >
                <li  >vyhnúť sa situáciám, v ktorých osobný záujem môže ovplyvniť profesionálne rozhodovanie,</li>
                <li  >oznámiť potenciálny konflikt záujmov garantovi alebo vedeniu,</li>
                <li  >zdržať sa akýchkoľvek aktivít, ktoré by mohli poškodiť dôveryhodnosť platformy Profivzdelávanie.sk spoločnosti Poradca podnikateľa.</li>
            </ul>
            <h1 className="sectionTitle">7. Pravidlá komunikácie a správania</h1>
            <ul >
                <li  >komunikácia musí byť založená na úcte, pravdivosti a profesionalite,</li>
                <li  >používanie nevhodného jazyka, diskriminačných vyjadrení alebo prejavov je neprípustné,</li>
                <li  >pracovníci musia dodržiavať kultúrne normy a zásady bezpečného pracovného prostredia.</li>
            </ul>
            <h1 className="sectionTitle">8. Mlčanlivosť a ochrana údajov</h1>
            <ul >
                <li  >všetky osobné údaje účastníkov sú dôverné,</li>
                <li  >pracovníci musia postupovať v súlade s GDPR a internými smernicami o ochrane údajov,</li>
                <li  >informácie z hodnotení, testov či spätnej väzby musia byť chránené pred zneužitím.</li>
            </ul>
            <h1 className="sectionTitle">9. Profesionalita a odborný rozvoj</h1>
            <ul >
                <li  >všetci zamestnanci a spolupracovníci sú povinní priebežne aktualizovať svoje odborné kompetencie,</li>
                <li  >profesijné zlyhania musia byť riešené konštruktívne, s cieľom podporiť zlepšenie.</li>
            </ul>
            <h1 className="sectionTitle">10. Etické zásady pre výber a hodnotenie personálu</h1>
            <ul >
                <li  >výber lektorov a garantov musí byť transparentný, objektívny a založený na preukázateľných kompetenciách,</li>
                <li  >hodnotenie výkonu musí byť spravodlivé, vecné a podložené merateľnými ukazovateľmi,</li>
                <li  >diskriminácia z akéhokoľvek dôvodu je prísne zakázaná.</li>
            </ul>
            <h1 className="sectionTitle">11. Porušenie etického kódexu</h1>
            <ul >
                <li  >porušenie kódexu môže viesť k disciplinárnym opatreniam, ukončeniu spolupráce alebo iným zásahom,</li>
                <li  >závažné porušenia môžu byť nahlásené príslušným orgánom,</li>
                <li  >všetci pracovníci sú zodpovední za nahlásenie neetického správania.</li>
            </ul>
            <h1 className="sectionTitle">12. Rozšírené etické štandardy správania</h1>
            <p >Tieto štandardy predstavujú záväzné pravidlá, ktoré musia dodržiavať všetci pracovníci zapojení do vzdelávacích aktivít v platforme Profivzdelávanie.sk spoločnosti Poradca podnikateľa.</p>
            <h2 className="sectionTitle">12.1 Všeobecné etické štandardy</h2>
            <ul >
                <li  >konať vždy v súlade s legislatívou SR, internými smernicami PP a profesionálnymi štandardmi vzdelávania dospelých,</li>
                <li  >komunikovať otvorene, profesionálne a bez prejavov nadradenosti alebo manipulatívneho správania,</li>
                <li  >zabezpečiť rovnaké podmienky pre všetkých účastníkov bez ohľadu na vek, pohlavie, zdravotný stav, náboženstvo, etnický pôvod, sociálne postavenie či presvedčenie,</li>
                <li  >chrániť dobré meno spoločnosti Poradca podnikateľa a platformy Profivzdelávanie.sk,</li>
                <li  >rešpektovať autoritu garanta vzdelávania, interných metodikov a vedenia,</li>
                <li  >vyhýbať sa profesionálnym aj osobným konfliktom na pracovisku.</li>
            </ul>
            <h2 className="sectionTitle">12.2 Štandardy správania lektora</h2>
            <ul >
                <li  >poskytovať odborné informácie, ktoré sú presné, aktuálne a overené,</li>
                <li  >neprezentovať osobné názory ako odborné fakty,</li>
                <li  >používať primerané didaktické metódy a zabezpečiť aktívne zapojenie účastníkov,</li>
                <li  >vytvárať bezpečné, inkluzívne, nekonfliktné vzdelávacie prostredie,</li>
                <li  >reagovať na podnety účastníkov trpezlivo a s odbornou argumentáciou,</li>
                <li  >nevyužívať čas školenia na osobnú propagáciu, marketing alebo predaj produktov,</li>
                <li  >dodržiavať časový harmonogram, termíny, štruktúru obsahu a organizačné pokyny,</li>
                <li  >zabezpečiť, aby obsah nebol v rozpore s právnymi predpismi SR.</li>
            </ul>
            <h2 className="sectionTitle">12.3 Štandardy správania garanta vzdelávania</h2>
            <ul >
                <li  >vykonávať odborný dohľad nestranne, vecne a transparentne,</li>
                <li  >nezasahovať do výučby spôsobom, ktorý by mohol narušiť autoritu lektora pred účastníkmi,</li>
                <li  >zabezpečiť pravidelnú aktualizáciu obsahu podľa legislatívnych zmien,</li>
                <li  >poskytovať konštruktívnu spätnú väzbu bez kritiky ad hominem,</li>
                <li  >priebežne sledovať kvalitu lektorov a navrhovať profesijné vzdelávanie,</li>
                <li  >riešiť sťažnosti účastníkov objektívne a s dôrazom na fakty.</li>
            </ul>
            <h2 className="sectionTitle">12.4 Štandardy administratívnej a organizačnej podpory</h2>
            <ul >
                <li >poskytovať presné informácie pred, počas a aj po školení,</li>
                <li >zabezpečiť technické podmienky podľa štandardov PP,</li>
                <li >komunikovať trpezlivo a profesionálne aj v konfliktných situáciách,</li>
                <li >dodržiavať princípy GDPR a mlčanlivosti,</li>
                <li >byť zodpovedným kontaktom pre účastníkov.</li>
            </ul>
            <h1 className="sectionTitle">13. Kompetenčné profily</h1>
            <p >Kompetenčné profily predstavujú minimálne požiadavky pre výkon jednotlivých rolí v rámci vzdelávania.</p>
            <h2 className="sectionTitle">13.1 Lektor – kompetenčný profil</h2>
            <p ><strong>Odborné kompetencie:</strong></p>
            <ul >
                <li >min. 3 roky odbornej praxe alebo preukázateľné odborné znalosti min. 1 rok,</li>
                <li >prehľad o platnej legislatíve a sektorových normách,</li>
                <li >skúsenosti s výučbou dospelých (výhoda).</li>
            </ul>
            <p ><strong>Pedagogické kompetencie:</strong></p>
            <ul >
                <li  >schopnosť vysvetliť odborný obsah zrozumiteľne a prakticky,</li>
                <li  >zvládanie diskusie, facilitácie a riadenia skupiny,</li>
                <li  >používanie pestrých didaktických metód.</li>
            </ul>
            <p ><strong>Osobnostné kompetencie:</strong></p>
            <ul >
                <li  >kultivovaná komunikácia,</li>
                <li  >zodpovednosť, spoľahlivosť,</li>
                <li  >časový manažment.</li>
            </ul>
            <h2 className="sectionTitle">13.2 Garant vzdelávania – kompetenčný profil</h2>
            <p ><strong>Odborné kompetencie:</strong></p>
            <ul >
                <li  >min. 5 rokov praxe v príslušnej oblasti,</li>
                <li  >schopnosť posúdiť odbornú správnosť obsahu,</li>
                <li  >znalosť legislatívnych rámcov v danej oblasti.</li>
            </ul>
            <p ><strong>Metodické kompetencie:</strong></p>
            <ul >
                <li  >schopnosť navrhovať vzdelávacie programy,</li>
                <li  >tvorba syláb, metodických odporúčaní a výstupov vzdelávania.</li>
            </ul>
            <p ><strong>Osobnostné kompetencie:</strong></p>
            <ul >
                <li  >objektívnosť, nestrannosť,</li>
                <li  >schopnosť poskytovať profesionálnu spätnú väzbu.</li>
            </ul>
            <h2 className="sectionTitle">13.3 Administratívna podpora – kompetenčný profil</h2>
            <p ><strong>Organizačné kompetencie:</strong></p>
            <ul >
                <li  >orientácia v procesoch PP,</li>
                <li  >spoľahlivé dodržiavanie termínov a presnosť.</li>
            </ul>
            <p ><strong>Komunikačné kompetencie:</strong></p>
            <ul >
                <li  >profesionálna komunikácia s účastníkmi a lektormi,</li>
                <li  >zvládanie stresových situácií.</li>
            </ul>
            <p ><strong>Technické kompetencie:</strong></p>
            <ul >
                <li  >práca s internými systémami,</li>
                <li  >základné technické znalosti vo vzťahu k online formám vzdelávania.</li>
            </ul>
            <h1 className="sectionTitle">14. Zodpovednosti jednotlivých rolí</h1>
            <h2 className="sectionTitle">14.1 Lektor</h2>
            <ul >
                <li  >pripraviť odborný obsah v súlade s metodickými požiadavkami PP,</li>
                <li  >realizovať školenia v súlade s etickým kódexom,</li>
                <li  >zúčastňovať sa hodnotení, hospitácií a pravidelných supervízií.</li>
            </ul>
            <h2 className="sectionTitle">14.2 Garant</h2>
            <ul >
                <li  >schvaľovať odborný obsah a jeho aktualizácie,</li>
                <li  >dohliadať na výkon lektora,</li>
                <li  >analyzovať spätnú väzbu a navrhovať opatrenia.</li>
            </ul>
            <h2 className="sectionTitle">14.3 Organizačná podpora</h2>
            <ul >
                <li  >administratívne zabezpečiť priebeh kurzov,</li>
                <li  >spolupracovať s účastníkmi, garantmi a lektormi,</li>
                <li  >zabezpečiť dokumentáciu, techniku a komunikáciu.</li>
            </ul>





        </Wrapper>
    );
};

export default EducationalCodeEthicsTemplate;
